/**
 * Utilitário para formatação de moeda baseado na currency da loja
 * Suporta: pt_BR (R$), en ($), es ($)
 */

/**
 * Retorna o símbolo da moeda baseado na currency
 * @param {string} currency - Currency da loja ('pt_BR', 'en', 'es')
 * @returns {string} Símbolo da moeda
 */
export const getCurrencySymbol = (currency = 'pt_BR') => {
  const currencySymbols = {
    'pt_BR': 'R$',
    'en': '$',
    'es': '$',
    'BRL': 'R$',
    'USD': '$',
    'EUR': '€',
    'USD_ES': '$'
  }
  
  return currencySymbols[currency] || currencySymbols['pt_BR']
}

export const getCurrencyConfig = (currency = 'pt_BR') => {
  const currencyMap = {
    'pt_BR': { locale: 'pt-BR', currency: 'BRL' },
    'en': { locale: 'en-US', currency: 'USD' },
    'es': { locale: 'en-US', currency: 'USD' },
    'BRL': { locale: 'pt-BR', currency: 'BRL' },
    'USD': { locale: 'en-US', currency: 'USD' },
    'EUR': { locale: 'es-ES', currency: 'EUR' },
    'USD_ES': { locale: 'es-ES', currency: 'USD' }
  }
  
  return currencyMap[currency] || currencyMap['pt_BR']
}

export const formatShopPrice = (price, currency = 'pt_BR') => {
  const currencyConfig = getCurrencyConfig(currency)

  return new Intl.NumberFormat(currencyConfig.locale, {
    style: 'currency',
    currency: currencyConfig.currency
  }).format(price || 0)
}

